<template>
  <div>
    <b-form-group :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffication">
      <b-form-input type="text" v-model="currentRowChargePolicies.name" aria-describedby="inputFeedbackName" :state="currentRowChargePolicies.name.length > 0" />
      <b-form-invalid-feedback id="inputFeedbackName">
        {{ $t('Enter title') }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-tabs vertical pills card>
      <b-tab :title="$t('Main')">
        <b-card style="margin: 1%">
          <b-form-group :label="$t('Recalulation on service link creation')">
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isFirstRecalcFee">{{ $t('Periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isFirstRecalcIp">{{ $t('Traffic') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isFirstRecalcTel">{{ $t('Telephony') }}</b-form-checkbox>
          </b-form-group>
        </b-card>
        <b-card style="margin: 1%">
          <b-form-group :label="$t('Don`t charge without block')">
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isDontChargeWithoutBlock">{{ $t('Periodic fee') }}</b-form-checkbox>
          </b-form-group>
        </b-card>
      </b-tab>
      <b-tab :title="$t('Recalculation on block')" style="padding: 0">
        <b-tabs pills card>
          <b-tab :title="$t('Administrative')" active>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isDontChargeAdmin">{{ $t('Do not charge periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcFeeAdmin">{{ $t('Recalc periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcIpAdmin">{{ $t('Decrease prepaid traffic') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcTelAdmin">{{ $t('Recalc prepaid telephony') }}</b-form-checkbox>
          </b-tab>
          <b-tab :title="$t('UserCP')">
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isDontChargeUser">{{ $t('Do not charge periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcFeeUser">{{ $t('Recalc periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcIpUser">{{ $t('Decrease prepaid traffic') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcTelUser">{{ $t('Recalc prepaid telephony') }}</b-form-checkbox>
          </b-tab>
          <b-tab :title="$t('System')">
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isDontChargeSystem">{{ $t('Do not charge periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcFeeSystem">{{ $t('Recalc periodic fee') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcIpSystem">{{ $t('Decrease prepaid traffic') }}</b-form-checkbox>
            <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRecalcTelSystem">{{ $t('Recalc prepaid telephony') }}</b-form-checkbox>
          </b-tab>
        </b-tabs>
      </b-tab>
      <b-tab :title="$t('Repay')">
        <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRepayOnBlockExpire">{{ $t('On block expire') }}</b-form-checkbox>
        <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRepayOnPayment">{{ $t('On payment') }}</b-form-checkbox>
        <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRepayOnAcctPeriodEnd">{{ $t('On charge period end') }}</b-form-checkbox>
        <b-form-checkbox switch size="lg" :disabled="!!currentChargePolicy" v-model="isRepayOnRemove">{{ $t('On remove service link') }}</b-form-checkbox>
      </b-tab>
      <b-tab :title="$t('System blocking')">
        <b-row align-h="center">
          <md-button class="md-raised" @click="addTime" v-if="isTariffication">{{ $t('Add block timemarks') }}</md-button>
        </b-row>
        <b-row v-if="time.length > 0">
          <b-col>
            <h4 style="font-weight:bold">{{ $t('Hour') }}</h4>
          </b-col>
          <b-col>
            <h4 style="font-weight:bold">{{ $t('Minute') }}</h4>
          </b-col>
          <b-col v-if="isTariffication">
          </b-col>
        </b-row>
        <b-row v-for="item in time" v-bind:key="item.id" style="margin-top:0.2rem">
          <b-col>
            <b-input style="max-height:25px" v-model="item.hour" :disabled="!!currentChargePolicy"/>
          </b-col>
          <b-col>
            <b-input style="max-height:25px" v-model="item.minute" :disabled="!!currentChargePolicy"/>
          </b-col>
          <b-col v-if="isTariffication">
            <i style="margin-top:0.4rem" @click.stop="deleteTime(item)" class="danger fa fa-trash-alt fa-lg"/>
          </b-col>
        </b-row>
        <b-form-checkbox style="margin-top:1rem" switch size="lg" :disabled="!!currentChargePolicy" v-model="isBlockOnfundsLack">{{ $t('Set system block on funds lack') }}</b-form-checkbox>
        <b-form-checkbox style="margin-top:1rem" switch size="lg" :disabled="!!currentChargePolicy" v-model="isAddTaxesToChargeWith0x10000">{{ $t('Consider charge + taxes with system block on funds lack') }}</b-form-checkbox>
      </b-tab>
    </b-tabs>
    <b-row v-if="!!currentChargePolicy">
      <b-col cols="10">
      </b-col>
      <b-col>
        <md-button class="md-raised" @click="hideFormChargePolicies" >Ok</md-button>
      </b-col>
    </b-row>

    <modal-ok-cancel v-if="isTariffication" @save="saveChargePolicy" @cancel="hideFormChargePolicies" size="lg"/>
  </div>
</template>

<script>
export default {
  props: {
    isTariffication: null,
    currentChargePolicy: null,
    currentRowChargePolicies: null
  },
  data () {
    return {
      chargePolicy: {
        'flags': 0,
        'name': '',
        'timecheks': []
      },
      time: [],
      timeId: 0,
      newTime: {
        'hour': 0,
        'minute': 0,
        'id': 0
      },
      flagDontChargeSystem: 0x1,
      flagDontChargeUser: 0x2,
      flagDontChargeAdmin: 0x4,
      /* recalculate periodic fee in blocks */
      flagRecalcFeeSystem: 0x8,
      flagRecalcFeeUser: 0x10,
      flagRecalcFeeAdmin: 0x20,
      /* decrease prepaid traffic in blocks */
      flagRecalcIpSystem: 0x40,
      flagRecalcIpUser: 0x80,
      flagRecalcIpAdmin: 0x100,
      /* decrease prepaid tel units */
      flagRecalcTelSystem: 0x200,
      flagRecalcTelUser: 0x400,
      flagRecalcTelAdmin: 0x800,
      /* system block options */
      flagBlockOnFundsLack: 0x10000,
      /* don't charge periodic fee without blocks */
      flagDontChargeWithoutBlock: 0x20000,
      /* slink creation options */
      flagFirstRecalcFee: 0x80000,
      flagFirstRecalcIp: 0x100000,
      flagFirstRecalcTel: 0x200000,
      /* fee repay options */
      flagRepayOnBlockExpire: 0x1000000,
      flagRepayOnPayment: 0x2000000,
      flagRepayOnAcctPeriodEnd: 0x4000000,
      flagRepayOnRemove: 0x8000000,
      flagAddTaxesToChargeWith0x10000: 0x20000000,

      isDontChargeSystem: false,
      isDontChargeUser: false,
      isDontChargeAdmin: false,
      isRecalcFeeSystem: false,
      isRecalcFeeUser: false,
      isRecalcFeeAdmin: false,
      isRecalcIpSystem: false,
      isRecalcIpUser: false,
      isRecalcIpAdmin: false,
      isRecalcTelSystem: false,
      isRecalcTelUser: false,
      isRecalcTelAdmin: false,

      isBlockOnfundsLack: false,

      isDontChargeWithoutBlock: false,

      isFirstRecalcFee: false,
      isFirstRecalcIp: false,
      isFirstRecalcTel: false,

      isRepayOnBlockExpire: false,
      isRepayOnPayment: false,
      isRepayOnAcctPeriodEnd: false,
      isRepayOnRemove: false,
      isAddTaxesToChargeWith0x10000: false
    }
  },
  methods: {
    hideFormChargePolicies () {
      this.$emit('hideFormChargePolicies')
      this.$emit('hideModalChargePolicies')
    },
    load () {
      if (this.currentChargePolicy || this.currentRowChargePolicies) {
        if (this.currentChargePolicy) {
          this.chargePolicy = this.currentChargePolicy
        } else {
          this.chargePolicy = this.currentRowChargePolicies
        }
        if (this.chargePolicy.blockchecktimemarks) {
          for (let i in this.chargePolicy.blockchecktimemarks) {
            this.newTime = JSON.parse(JSON.stringify(this.newTime))
            this.newTime.id = ++this.timeId
            this.newTime.hour = Math.round(this.chargePolicy.blockchecktimemarks[i] / 3660)
            this.newTime.minute = (this.chargePolicy.blockchecktimemarks[i] / 60) % 60
            this.time.push(this.newTime)
          }
        }
        if (this.chargePolicy.flags) {
          if (this.chargePolicy.flags & this.flagDontChargeSystem) {
            this.isDontChargeSystem = true
          }
          if (this.chargePolicy.flags & this.flagDontChargeUser) {
            this.isDontChargeUser = true
          }
          if (this.chargePolicy.flags & this.flagDontChargeAdmin) {
            this.isDontChargeAdmin = true
          }
          if (this.chargePolicy.flags & this.flagRecalcFeeSystem) {
            this.isRecalcFeeSystem = true
          }
          if (this.chargePolicy.flags & this.flagRecalcFeeUser) {
            this.isRecalcFeeUser = true
          }
          if (this.chargePolicy.flags & this.flagRecalcFeeAdmin) {
            this.isRecalcFeeAdmin = true
          }
          if (this.chargePolicy.flags & this.flagRecalcIpSystem) {
            this.isRecalcIpSystem = true
          }
          if (this.chargePolicy.flags & this.flagRecalcIpUser) {
            this.isRecalcIpUser = true
          }
          if (this.chargePolicy.flags & this.flagRecalcIpAdmin) {
            this.isRecalcIpAdmin = true
          }
          if (this.chargePolicy.flags & this.flagRecalcTelSystem) {
            this.isRecalcTelSystem = true
          }
          if (this.chargePolicy.flags & this.flagRecalcTelUser) {
            this.isRecalcTelUser = true
          }
          if (this.chargePolicy.flags & this.flagRecalcTelAdmin) {
            this.isRecalcTelAdmin = true
          }
          if (this.chargePolicy.flags & this.flagBlockOnFundsLack) {
            this.isBlockOnfundsLack = true
          }
          if (this.chargePolicy.flags & this.flagDontChargeWithoutBlock) {
            this.isDontChargeWithoutBlock = true
          }
          if (this.chargePolicy.flags & this.flagFirstRecalcFee) {
            this.isFirstRecalcFee = true
          }
          if (this.chargePolicy.flags & this.flagFirstRecalcIp) {
            this.isFirstRecalcIp = true
          }
          if (this.chargePolicy.flags & this.flagFirstRecalcTel) {
            this.isFirstRecalcTel = true
          }
          if (this.chargePolicy.flags & this.flagRepayOnBlockExpire) {
            this.isRepayOnBlockExpire = true
          }
          if (this.chargePolicy.flags & this.flagRepayOnPayment) {
            this.isRepayOnPayment = true
          }
          if (this.chargePolicy.flags & this.flagRepayOnAcctPeriodEnd) {
            this.isRepayOnAcctPeriodEnd = true
          }
          if (this.chargePolicy.flags & this.flagRepayOnRemove) {
            this.isRepayOnRemove = true
          }
          if (this.chargePolicy.flags & this.flagAddTaxesToChargeWith0x10000) {
            this.isAddTaxesToChargeWith0x10000 = true
          }
        }
      }
    },
    addTime () {
      this.newTime.id = ++this.timeId
      this.time.push(JSON.parse(JSON.stringify(this.newTime)))
      this.newTime.minute = this.newTime.hour = 0
    },
    deleteTime (item) {
      this.time = this.time.filter((el, idx, arr) => {
        return el.id !== item.id
      })
    },
    saveChargePolicy () {
      if (!this.currentRowChargePolicies.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.chargePolicy.name = this.currentRowChargePolicies.name
      for (let i in this.time) {
        this.time[i].timemark = this.time[i].hour * 3600 + this.time[i].minute * 60
        delete this.time[i].id
        delete this.time[i].hour
        delete this.time[i].minute
      }
      this.chargePolicy.timecheks = this.time
      this.chargePolicy.flags = 0
      this.chargePolicy.flags += this.isDontChargeSystem ? this.flagDontChargeSystem : 0
      this.chargePolicy.flags += this.isDontChargeUser ? this.flagDontChargeUser : 0
      this.chargePolicy.flags += this.isDontChargeAdmin ? this.flagDontChargeAdmin : 0
      this.chargePolicy.flags += this.isRecalcFeeSystem ? this.flagRecalcFeeSystem : 0
      this.chargePolicy.flags += this.isRecalcFeeUser ? this.flagRecalcFeeUser : 0
      this.chargePolicy.flags += this.isRecalcFeeAdmin ? this.flagRecalcFeeAdmin : 0
      this.chargePolicy.flags += this.isRecalcIpSystem ? this.flagRecalcIpSystem : 0
      this.chargePolicy.flags += this.isRecalcIpUser ? this.flagRecalcIpUser : 0
      this.chargePolicy.flags += this.isRecalcIpAdmin ? this.flagRecalcIpAdmin : 0
      this.chargePolicy.flags += this.isRecalcTelSystem ? this.flagRecalcTelSystem : 0
      this.chargePolicy.flags += this.isRecalcTelUser ? this.flagRecalcTelUser : 0
      this.chargePolicy.flags += this.isRecalcTelAdmin ? this.flagRecalcTelAdmin : 0
      this.chargePolicy.flags += this.isBlockOnfundsLack ? this.flagBlockOnFundsLack : 0
      this.chargePolicy.flags += this.isDontChargeWithoutBlock ? this.flagDontChargeWithoutBlock : 0
      this.chargePolicy.flags += this.isFirstRecalcFee ? this.flagFirstRecalcFee : 0
      this.chargePolicy.flags += this.isFirstRecalcIp ? this.flagFirstRecalcIp : 0
      this.chargePolicy.flags += this.isFirstRecalcTel ? this.flagFirstRecalcTel : 0
      this.chargePolicy.flags += this.isRepayOnBlockExpire ? this.flagRepayOnBlockExpire : 0
      this.chargePolicy.flags += this.isRepayOnPayment ? this.flagRepayOnPayment : 0
      this.chargePolicy.flags += this.isRepayOnAcctPeriodEnd ? this.flagRepayOnAcctPeriodEnd : 0
      this.chargePolicy.flags += this.isRepayOnRemove ? this.flagRepayOnRemove : 0
      this.chargePolicy.flags += this.isAddTaxesToChargeWith0x10000 ? this.flagAddTaxesToChargeWith0x10000 : 0
      let response = this.chargePolicy.policy_id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICIES', this.chargePolicy)
        : this.$store.dispatch('Tariffing/CREATE_CHARGE_POLICIES', this.chargePolicy)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_CHARGE_POLICIES')
          this.hideFormChargePolicies()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/chargePolicies/editModal.vue